import mutations from './mutations';
import actions from './actions';

const initialState = () => ({
  mutualFundProducts: null,
  mutualFundVideos: null,
  mutualFundArticles: null,
  mutualFundTestimonies: null,
});

export default {
  namespaced: true,
  state: initialState,
  mutations,
  actions,
};
